import React, { useEffect } from "react";
import Technology from "web/assets/images/change-technology.webp";
import AOS from "aos";

import {
  Container,
  Wrapper,
} from "web/pages/public/landing-page/HowItWork/ChangingTechnology/ChangingTechnologyStyled";

const ChangingTechnology = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
    });
  }, []);
  return (
    <Container data-aos="fade-up" data-aos-delay="400">
      <Wrapper>
        <h1>This is game-changing technology disguised as an old friend.</h1>
        <h2>
          Inspiration and best practices for PalletTrader’s functionality and
          design come from the most successful e-commerce and community sites in
          the world, including Amazon, eBay, LinkedIn, Facebook, and others. The
          result? A platform that looks and feels familiar, and will be
          comfortable to use for anyone who has shopped on an e-commerce
          website.
        </h2>
        <img src={Technology} alt="Technology" />
      </Wrapper>
    </Container>
  );
};

export default ChangingTechnology;
